import { useSelector } from 'react-redux';

import { selectMyProfile } from '@app/modules/my-profile';

const useAuthRole = () => {
  const authRole = useSelector(selectMyProfile);
  const isSuperAdmin = authRole?.roleId === 1;
  const isManager = authRole?.roleId === 2;
  const isEmployee = authRole?.roleId === 5;
  const isIntern = authRole?.roleId === 3;
  return { isManager, isSuperAdmin, isEmployee, isIntern };
};

export { useAuthRole };
